export default __webpack_public_path__ + "static/media/credit-card.fe246359.svg";